module.exports = __webpack_public_path__ + "img/popup-game-sucai.7d3882f7.png";